// Duplicate a drawing (sheet) so a second takeoff can be done on the same file. Pure part: what the copy is called and what
// sp_SaveTakeoffDrawingSheet is sent. The copy gets the FILE (or the stored-set pointer), page, scale, position, opacity,
// rotation and sheet number / discipline of the original — and NOTHING drawn on it: rooms and conditions belong to a sheet by
// SheetID (db/21, db/37), and the new sheet is a new row, so it starts empty by construction. It is not a key sheet.

/** "Floor Plan" -> "Floor Plan (copy)", then "(copy 2)", "(copy 3)" … — never a name another drawing already has. */
export function duplicateSheetName(name, existingNames = []) {
  const base = String(name || "Drawing").replace(/\s*\(copy(?: \d+)?\)\s*$/i, "").trim() || "Drawing";
  const taken = new Set((existingNames || []).map(n => String(n || "").trim().toLowerCase()));
  let candidate = `${base} (copy)`, n = 1;
  while (taken.has(candidate.toLowerCase())) { n += 1; candidate = `${base} (copy ${n})`; }
  return candidate.slice(0, 200);
}

/** A drawing can be duplicated when it carries a file or a stored-set pointer. */
export const canDuplicateSheet = (sheet) => !!sheet && !!(sheet.BackgroundImage || sheet.SetID);

/**
 * { payload, image } for sp_SaveTakeoffDrawingSheet (create: no sheet_id). A set-backed sheet is sent as its set_id (the file is
 * not copied); an uploaded file is sent as the image parameter. Only values the original actually has are sent.
 */
export function duplicateSheetRequest(sheet, revisionId, name) {
  const p = { revision_id: revisionId, sheet_name: name };
  const put = (k, v) => { if (v !== null && v !== undefined && v !== "") p[k] = v; };
  put("image_page", sheet.ImagePage);
  put("image_scale_ft_per_px", sheet.ImageScaleFtPerPx);
  put("image_ft_per_inch", sheet.ImageFtPerInch);
  put("image_x", sheet.ImageX);
  put("image_y", sheet.ImageY);
  put("image_opacity", sheet.ImageOpacity);
  put("image_rotation", sheet.ImageRotation);
  put("sheet_number", sheet.SheetNumber);
  put("discipline", sheet.Discipline);
  put("file_hash", sheet.FileHash);
  put("file_name", sheet.FileName);
  let image = null;
  if (sheet.SetID) p.set_id = sheet.SetID;
  else { p.image_is_pdf = sheet.ImageIsPdf ? 1 : 0; image = sheet.BackgroundImage; }
  // a set-backed sheet sends no file hash / name of its own: the proc takes them from the set
  if (sheet.SetID) { delete p.file_hash; delete p.file_name; }
  return { payload: p, image };
}
